import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { FormNotFoundDialogComponent } from '../dialogs/form-not-found-dialog/form-not-found-dialog.component';
import { ErrorDialogComponent } from '../dialogs/error-dialog/error-dialog.component';
import { LfwRouterService } from '../../route/lfw-router.service';
import { ErrorDetails } from './error-details';

@Injectable({
  providedIn: 'root'
})
export class DefaultDialogService {
  private readonly translate = inject(TranslateService);
  private readonly routerService = inject(LfwRouterService);
  private readonly dialog = inject(MatDialog);

  formNotFound(id: string | undefined): void {
    let data = '';
    if (id === undefined || id === '') {
      data = this.translate.instant('FORM.DLG_FORM_HAS_NO_ID');
    } else {
      data = this.translate.instant('FORM.DLG_FORM_ID_NOT_FOUND', { id: id });
    }
    const confirmDialog = this.dialog.open(FormNotFoundDialogComponent, {
      data: data,
      disableClose: true
    });
    confirmDialog.afterClosed().subscribe(() => {
      this.routerService.navigateBack();
    });
  }

  showSaveError(errorDetail: ErrorDetails | null): void {
    this.dialog.open(ErrorDialogComponent, {
      data: {
        title: this.translate.instant('DIALOGS.ERROR'),
        message: errorDetail?.error?.detail ?? this.translate.instant('FORM.DLG_SAVE_FAILED')
      },
      disableClose: true
    });
  }
}
